import { useBusinesses } from "./use-businesses";

export function useCurrentBusiness() {
  const { businesses, activeBusiness, switchBusiness, isLoadingBusinesses } = useBusinesses();
  
  return {
    businesses,
    currentBusiness: activeBusiness,
    setCurrentBusiness: switchBusiness,
    isLoading: isLoadingBusinesses
  };
}
